import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { ForumMain } from "@modules/forum";
import API from "@unisearch/helpers/api";

export const Forum = ({
  groupList,
  popularGroup,
  groupTopic,
  recentPost,
  postList,
}) => {
  return (
    <LayoutMain title="Forum">
      <ForumMain
        groupList={groupList}
        popularGroup={popularGroup}
        groupTopic={groupTopic}
        recentPost={recentPost}
        postList={postList}
      />
    </LayoutMain>
  );
};

export default Forum;

export async function getServerSideProps() {
  let props = {
    groupList: "",
    popularGroup: "",
    groupTopic: "",
    postList: "",
    recentPost: "",
  };

  try {
    await API.get(`/public/forum/all-group`).then((resp) => {
      if (!resp.error && resp.data) {
        props.groupList = resp.data;
      } else {
        props.groupList = "";
      }
    });

    await API.get(`/public/forum/popular-group`).then((resp) => {
      if (!resp.error && resp.data) {
        props.popularGroup = resp.data;
      } else {
        props.popularGroup = "";
      }
    });

    await API.post(`/public/forum-post/all-post-paginate-list`, {
      filter: {},
      sortOrder: "DESC",
      sortField: "forumPostId",
      pageNumber: 1,
      pageSize: 1,
    }).then((resp) => {
      if (!resp.error && resp.data) {
        props.postList = resp.data;
      } else {
        props.postList = "";
      }
    });

    await API.get(`/public/forum/group-topics`).then((resp) => {
      if (!resp.error && resp.data) {
        props.groupTopic = resp.data;
      } else {
        props.groupTopic = "";
      }
    });

    await API.post(`/public/forum-post/all-post-paginate-list`, {
      filter: {},
      sortOrder: "DESC",
      sortField: "forumPostId",
      pageNumber: 1,
      pageSize: 6,
    }).then((resp) => {
      if (!resp.error && resp.data) {
        props.recentPost = resp.data;
      } else {
        props.recentPost = "";
      }
    });

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
